import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/lib/i18n';

export default function AccessDenied({ role }) {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const r = (role || 'stylist').toLowerCase();

  let hint = t('access_stylist_hint');
  if (r === 'receptionist') hint = t('access_receptionist_hint');
  else if (r === 'manager') hint = t('access_manager_hint');

  return (
    <div className="min-h-[calc(100vh-0px)] flex items-center justify-center bg-[#faf8f5] px-4 py-12">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <Lock className="w-16 h-16 text-[#f0a500]" strokeWidth={1.75} aria-hidden />
        </div>
        <div className="space-y-2">
          <h1 className="font-poppins text-2xl font-bold text-[#1a1a2e]">{t('access_restricted')}</h1>
          <p className="text-gray-600 text-base leading-relaxed">{t('access_restricted_body', { role: r })}</p>
          <p className="text-sm text-gray-500 pt-2">{hint}</p>
        </div>
        <Button
          type="button"
          onClick={() => navigate('/')}
          className="h-12 px-8 rounded-xl bg-[#f0a500] hover:bg-[#d69400] text-[#1a1a2e] font-semibold text-base"
        >
          {t('go_to_dashboard')}
        </Button>
      </div>
    </div>
  );
}
